/** @type {import('../help-index.js').HelpSidebarItem} */
export const AGR_CAM_SUELOS_ITEM = {
  id: 'agro_suelos',
  screenId: 'agr-cam-suelos',
  label: 'Suelos',
  description: 'Consulta de capas, análisis de laboratorio y parámetros de suelo.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Registrás y consultás análisis de suelo por campo o zona, y mantenés el catálogo de parámetros que se miden (fósforo, materia orgánica, etc.).',
      },
      {
        title: 'Pestañas',
        bullets: [
          'Consulta — resumen de los últimos valores por profundidad.',
          'Análisis — lista y alta de análisis de laboratorio.',
          'Parámetros — qué se puede medir y en qué unidades.',
        ],
      },
      {
        title: 'Selector de lugar',
        fields: [
          {
            label: 'Campo',
            description: 'Campo al que aplica la consulta o el análisis.',
          },
          {
            label: 'Zona',
            description: 'Opcional. Acota la consulta a una zona del campo.',
          },
        ],
      },
      {
        title: 'Pestaña Consulta',
        paragraphs: [
          'Elegí campo (y zona si corresponde). Verás capas o valores recientes según profundidad (por ejemplo capacidad de campo, punto de marchitez, agua útil y otros parámetros cargados).',
        ],
      },
      {
        title: 'Pestaña Análisis — lista',
        bullets: [
          'Columnas típicas: Fecha de análisis, Laboratorio, Número de muestra, profundidad superior e inferior.',
          'El botón + abre un análisis nuevo.',
          'Tocá una fila para ver detalle; desde ahí podés editar o eliminar si tenés permiso.',
        ],
      },
      {
        title: 'Pestaña Análisis — formulario',
        fields: [
          {
            label: 'Campo / Zona',
            description: 'Dónde se tomó la muestra.',
          },
          {
            label: 'Laboratorio',
            description: 'Nombre del laboratorio que hizo el análisis.',
          },
          {
            label: 'Número de muestra',
            description: 'Identificador de la muestra en el informe.',
          },
          {
            label: 'Fecha de extracción',
            description: 'Cuándo se sacó la muestra en el campo.',
          },
          {
            label: 'Fecha del análisis',
            description: 'Fecha del informe de laboratorio.',
          },
          {
            label: 'Responsable',
            description: 'Quién tomó o cargó la muestra.',
          },
          {
            label: 'Lote',
            description: 'Referencia de lote si la usás en el establecimiento.',
          },
          {
            label: 'Ambiente',
            description: 'Ambiente o sector dentro del lote.',
          },
          {
            label: 'Profundidad superior / inferior (cm)',
            description: 'Rango de profundidad de la muestra (ej. 0–20 cm).',
          },
          {
            label: 'Ubicación GPS (opcional)',
            description: 'Tocá para marcar el punto en el mapa.',
          },
          {
            label: 'Resultados por parámetro',
            description:
              'Campos numéricos según los parámetros activos (pH, P, MO, etc.). Completá solo lo que traiga el informe.',
          },
          {
            label: 'Notas',
            description: 'Observaciones libres.',
          },
        ],
      },
      {
        title: 'Pestaña Parámetros',
        intro: 'Definís qué se puede cargar en un análisis.',
        fields: [
          {
            label: 'Nombre',
            description: 'Nombre del parámetro (ej. Materia orgánica).',
          },
          {
            label: 'Abreviatura',
            description: 'Sigla corta para listas y tablas.',
          },
          {
            label: 'Método',
            description: 'Método de laboratorio de referencia (opcional).',
          },
          {
            label: 'Unidad',
            description: 'Unidad de medida (%, ppm, meq, etc.).',
          },
          {
            label: 'Tipo de valor',
            description: 'Cómo se interpreta el dato (numérico u otro tipo previsto).',
          },
        ],
        paragraphs: [
          'Algunos parámetros vienen de fábrica (sistema). Podés agregar los tuyos con el botón +.',
        ],
      },
    ],
  },
}
